export const TEST_RESULTS_LOADED_SUCCESS = 'TEST_RESULTS_LOADED_SUCCESS';
export const NEW_TEST_RESULTS_COUNT_LOADED = 'NEW_TEST_RESULTS_COUNT_LOADED';
export const SELECTED_TEST_RESULT_CHANGED = 'SELECTED_TEST_RESULT_CHANGED';
export const TEST_RESULT_DETAILS_LOAD_SUCCESS = 'TEST_RESULT_DETAILS_LOAD_SUCCESS';
export const TESTRESULTS_TOGGLE_FILTER_PANEL = 'TESTRESULTS_TOGGLE_FILTER_PANEL';
export const TESTRESULTS_FILTER_OPTIONS_CHANGED = 'TESTRESULTS_FILTER_OPTIONS_CHANGED';
export const TEST_RESULT_GROUP_SORTED = 'TEST_RESULT_GROUP_SORTED';